import { Swiper, Navigation, Keyboard, Pagination, EffectFade } from 'swiper';

import 'swiper/css';
import 'swiper/css/navigation';
import 'swiper/css/pagination';
import 'swiper/css/effect-fade';

export default function initSwiper(element) {
	if ( element.dataset.swiperElement ) {

		const pincilSwiperOptions = {
			watchOverflow: true,
			speed: 500,
			keyboard: true,
			slidesPerGroup: 1,
			spaceBetween: 24,
			loop: false,
			modules: [Navigation, Keyboard],
			breakpoints: {
				1024: {
					slidesPerView: 6,
				},
				768: {
					slidesPerView: 4,
				},
				0: {
					slidesPerView: 1,
				},
			},
		}

		const heroMediaSwipreOptions = {
			watchOverflow: true,
			speed: 800,
			keyboard: true,
			loop: false,
			modules: [Navigation, Keyboard, Pagination, EffectFade],
			slidesPerView: 1,
			spaceBetween: 10,
			effect: 'fade',
			fadeEffect: {
				crossFade: true
			},
			pagination: {
				el: '.swiper-pagination',
				type: 'custom',
				renderCustom: function (swiper, current, total) {
					return current + '/' + (total );
				}
			},
			breakpoints: {
				1199: {
					autoHeight: true,
				},
				767: {
					autoHeight: false,
				},
				0: {
					autoHeight: true,
				},
			},
		}

		let options = {};

		let swiperElement = element.dataset.swiperElement;

		switch (swiperElement) {
			case "pencil-swiper":
				options = pincilSwiperOptions
				break;
			case "pencil-image-swiper":
				options = pincilSwiperOptions
				break;
			case "hero-media-swiper":
				options = heroMediaSwipreOptions
				break;
			default:
				options = pincilSwiperOptions;
		}

		if ( element.dataset?.swiperNext && element.dataset?.swiperPrev ) {
			// navigation buttons
			const navigation = {
				navigation: {
					nextEl: element.dataset.swiperNext ? `#${element.dataset.swiperNext}` : null,
					prevEl: element.dataset.swiperPrev ? `#${element.dataset.swiperPrev}` : null,
				},
			}

			options = {...options, ...navigation};
		}

		const on = {
			on: {
				init: function () {
					element.classList.remove("loading");
				},
			},
		}
		options = {...options, ...on};
		// init Swiper:
		const swiper = new Swiper(`.${element.dataset.swiperElement}`, options);
		// return swiper in case the swiper instance needs to be used
		return swiper;
	}
	return null;
}
